import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox-group',
  imports: [ReactiveFormsModule, NgClass, TranslatePipe, CommonModule],
  templateUrl: './checkbox-group.html',
  styleUrl: './checkbox-group.css'
})
export class CheckboxGroup {
  @Input() label = '';
  @Input() options: { label: string; value: string }[] = [];
  @Input() control!: FormControl; 
  @Output() valueChange = new EventEmitter<string[]>();

  toggleSelection(value: string) {
    const currentValue = this.control.value || [];
    const updatedValue = currentValue.includes(value)
      ? currentValue.filter((v: string) => v !== value)
      : [...currentValue, value];
    this.control.setValue(updatedValue);
    this.valueChange.emit(updatedValue);
  }

  isSelected(value: string): boolean {
    return this.control.value?.includes(value);
  }
}
